/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class o extends r{constructor(r,o){super(r,"int",1,(s,t,e)=>s.setUniform1i(r,o(t,e)))}}export{o as IntegerPassUniform};
